
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'LiveLabel'
})
export default class LiveLabel extends Vue {}
